import React from 'react';
import { GROUPS_KEYS } from '@sonifi/wb-group/store/groupsConstants';
import GroupSelector from '@sonifi/wb-group/components/GroupSelector';
import { NAV_KEYS, PRODUCTS_NAV } from '../constants/wbNavConstants';
import WbNavStyles from '../styles/WbNav.module.css';
import RevenueCenterSelector from './RevenueCenterSelector';
import { useWbProductNav } from '../hooks/useWbProductNav';

const getTitle = (nv, currentGroup) => {
  const title = PRODUCTS_NAV[nv.product](currentGroup);

  return title;
};

const ProductsNav = ({ secondaryNav, tertiaryNav }) => {
  const {
    productsNavState,
    productTabs,
    group,
    handleGroupChange,
    onChangeRevenueCenter,
    handleTertiaryNavClick,
    handleSecondaryNavClick,
  } = useWbProductNav({ secondaryNav, tertiaryNav });

  return (
    <>
      <ul className="nav nav-tabs" role="tablist">
        <li role="presentation">
          <GroupSelector
            customClass={`site-selector ${WbNavStyles.groupSelector}`}
            defaultValue={group.id}
            groupKey={GROUPS_KEYS.allGroups}
            onChange={(groupSel) => handleGroupChange({ groupSel, goHome: true })}
          />
        </li>
        {productTabs?.navChildren.map((nv) => (
          <li
            key={nv.key}
            className={
              nv.key === productsNavState.secondaryNavState?.key ? 'active' : ''
            }
            role="presentation"
          >
            {group?.id ? (
              <a
                role="tab"
                data-toggle="tab"
                onClick={() => handleSecondaryNavClick(nv)}
              >
                {getTitle(nv, group)}
              </a>
            ) : null}
          </li>
        ))}
      </ul>
      {productsNavState.secondaryNavState?.navChildren?.length ? (
        <ul className="nav nav-tabs tertiary-tabs">
          {productsNavState.secondaryNavState.key === NAV_KEYS.inRoomDining ? (
            <RevenueCenterSelector onChange={onChangeRevenueCenter} />
          ) : null}
          {productsNavState.secondaryNavState.navChildren.map((nv) => (
            <li
              key={nv.key}
              className={
                nv.key === productsNavState.tertiaryNavState?.key
                  ? 'active'
                  : ''
              }
              role="presentation"
            >
              <a
                role="tab"
                data-toggle="tab"
                onClick={() => handleTertiaryNavClick(nv)}
              >
                {nv.title}
              </a>
            </li>
          ))}
        </ul>
      ) : null}
    </>
  );
};

export default ProductsNav;
